import React, { forwardRef } from 'react';
import { StyleSheet, Text, TextProps } from 'react-native';
import theme from 'shared/styles/theme';

const BodyXSBoldText = forwardRef<Text, TextProps>(
  ({ children, style, ...props }, ref) => {
    return (
      <Text ref={ref} style={[styles.bodyXSBoldText, style]} {...props}>
        {children}
      </Text>
    );
  },
);

const styles = StyleSheet.create({
  bodyXSBoldText: {
    ...theme.typography.body.xsBold,
    color: theme.color.text.primary,
  },
});

export default BodyXSBoldText;
